import React from 'react';
import { useNavigate } from 'react-router-dom';

const ReportType = () => {
  const navigate = useNavigate();

  return (
    <div className="report-type">
      <div className="report-type-inner">
        <h1 className="report-type-title">What are you reporting?</h1>
        <div className="report-type-grid">
          <button
            className="start-card"
            onClick={() => navigate('/code-report')}
          >
            <h2 className="start-card-title">Private</h2>
            <p>Mold, uncut grass, fallen tree, etc.</p>
          </button>
          <button
            className="start-card"
            onClick={() => navigate('/public-report')}
          >
            <h2 className="start-card-title">Public</h2>
            <p>Streetlights, roads, parks, public buildings, etc.</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportType;

